import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { TYPE, URL } from '../../../constant';
import { useUserInfo } from '../../../hooks';
import {
  Login, Join, PwInquiry, PwInquirySuccess, MyPage,
  LearnerChoice, AppIdSign, AppIdSignSuccess,
  MemberAuth, MemberAuthSuccess
} from './';

const {
  LOGIN,
  JOIN,
  MY_PAGE,
  APP_ID_SIGN,
  APP_ID_SIGN_SUCCESS,
  LEARNER_CHOICE,
  PW_INQUIRY,
  PW_INQUIRY_SUCCESS,
  GM_MEMBER_AUTH,
  GM_MEMBER_AUTH_SUCCESS
} = URL.ACCOUNT;

// 교문 탈패드와, 교문에서 각각 접속 불가능한 페이지
const GM_APP_INACCESSIBLE = [APP_ID_SIGN, APP_ID_SIGN_SUCCESS];
const GM_INACCESSIBLE = [LOGIN, JOIN.I, PW_INQUIRY, PW_INQUIRY_SUCCESS, MY_PAGE, GM_MEMBER_AUTH, GM_MEMBER_AUTH_SUCCESS];

function AccountGM() {
  const { info } = useUserInfo();
  return (
    <Switch>
      
      {
        /**
         * 교문 탈패드
         */
        info.entryType === TYPE.ENTRY_TYPE.GM_APP && (
          <>
            <Route path={LOGIN} component={Login} />
            <Route path={JOIN.I} component={Join} />
            <Route path={LEARNER_CHOICE} component={LearnerChoice} /> {/* 학습자선택 */}
            <Route path={PW_INQUIRY} component={PwInquiry} />
            <Route path={PW_INQUIRY_SUCCESS} component={PwInquirySuccess} />
            <Route path={MY_PAGE} component={MyPage} />
            <Route path={GM_MEMBER_AUTH} component={MemberAuth}/>
            <Route path={GM_MEMBER_AUTH_SUCCESS} component={MemberAuthSuccess} />
            <Route path={GM_APP_INACCESSIBLE}>
              <Redirect to={ info?.userId ? URL.SELECT_LEARNING : URL.ACCOUNT.LOGIN}/>
            </Route>
          </>
        )
      }
      {
        /**
         * 교문
         */
        info.entryType === TYPE.ENTRY_TYPE.GM && (
          <>
            <Route path={APP_ID_SIGN} component={AppIdSign}/>
            <Route path={APP_ID_SIGN_SUCCESS} component={AppIdSignSuccess} />
            <Route path={GM_INACCESSIBLE}>
              <Redirect to={ URL.SELECT_LEARNING}/>
            </Route>
          </>
        )
      }
    </Switch>
  );
}

export default AccountGM;